<div class="md-table admin-scroll-layout primus-solr-table-container">
  <!-- Show progressbar if loading -->
  @if (dataSource.loading$ | async) {
    <mat-progress-bar
      mode="indeterminate"
      color="accent"
    ></mat-progress-bar>
  }

  <!-- start table -->
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
  >
    <!-- Define column for checkboxes making each row selectable if needed -->
    <ng-container
      matColumnDef="select"
      [sticky]="isLargeScreen"
    >
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (click)="selectAll($event)"
          (keydown)="null"
          [checked]="selectionState === 'all'"
          [indeterminate]="selectionState === 'some'"
        ></mat-checkbox>

        <span class="admin-table-select-all-name">
          {{'TRANS__EDIT_FIELD__CHOOSE' | translate}}
        </span>
      </th>

      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="dataSource.toggleSelection(row)"
          (keydown)="null"
          [disabled]="!enableSelection && !enableMultiSelection"
          [checked]="dataSource.isSelected(row)"
        ></mat-checkbox>
      </td>
    </ng-container>

    <!-- Generate columns for each provided column -->
    @for (col of columns; track $index) {
      <ng-container
        [matColumnDef]="col"
        [sticky]="col === 'name.name' && isLargeScreen"
      >
        <th mat-header-cell *matHeaderCellDef mat-sort-header="">
          {{ getColumnLabel(col) | translate }}
        </th>

        <td
          mat-cell
          *matCellDef="let row"
          [ngClass]="{'image-col': col === imageProperty}"
          (click)="rowClicked.emit(row)"
          (keydown)="null"
        >
          <!-- Display as image if the column is of type image -->
          @if (col === imageProperty && !!row[imageProperty]) {
            <app-thumbnail
              [imageIdField]="imageProperty"
              [item]="row"
              class="primus-table-thumbnail"
              stylingClass="profile-image"
            ></app-thumbnail>
          }
          @else if (col === imageProperty && !row[imageProperty]) {
            <!-- Display broken image if image-column and no image -->
            <mat-icon class="none-profile-image">
              image
            </mat-icon>
          }
          @else if (col !== imageProperty && !isBooleanValue(row, col)) {
            <!-- Display value -->
            <span
              [innerHTML]="getRowValue(row, col)"
            ></span>
          }
          @else if (isBooleanValue(row, col)) {
            <!-- Display boolean value -->
            <span>
              <mat-checkbox
                [disabled]="true"
                [checked]="!getRowValue(row, col)"
              ></mat-checkbox>
            </span>
          }
        </td>
      </ng-container>
    }

    <!-- Add column for edit-button if needed -->
    <ng-container
      matColumnDef="editButton"
      [stickyEnd]="isLargeScreen"
    >
      <th
        mat-header-cell
        *matHeaderCellDef
      ></th>

      <td mat-cell *matCellDef="let row">
        <div class="table-column-width-override">
          <button
            mat-icon-button
            class="text-blue-hover"
            (click)="handleEditRow(row)"
          >
            <mat-icon>
              edit
            </mat-icon>
          </button>

          @if (linkToObjectPage) {
            <button
              mat-icon-button
              (click)="goToCurrentObject(row)"
            >
              <mat-icon color="accent">
                arrow_forward
              </mat-icon>
            </button>
          }
        </div>
      </td>
    </ng-container>

    <!-- Add definition for rows -->
    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

    <tr
      mat-row *matRowDef="let row; columns: columnsToDisplay"
      [ngClass]="{'primus-table-row': enableSelection || enableMultiSelection}"
    ></tr>
  </table>
</div>

<!-- Add paginator -->

<div class="admin-action-toolbar">
  <span class="add-row-button-wrapper">
    @if (enableAddRowButton) {
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="handleAddRow()"
      >
        <mat-icon matPrefix>
          add
        </mat-icon>

        <span class="bold uppercase">
          {{ (addRowButtonLabel || '') | translate }}
        </span>
      </button>
    }

    @if (enableKulturNav) {
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="handleKulturNavImport()"
      >
        <mat-icon matPrefix>
          add
        </mat-icon>

        <span class="bold uppercase">
          {{ 'TRANS__FIELD_SELECT__GET_FROM_AUTHORITY' | translate }}
        </span>
      </button>
    }
  </span>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 25, 50, 100, 200]"
    [pageSize]="25"
    showFirstLastButtons
  ></mat-paginator>
</div>
